






















import { Vue, Component, Prop } from 'vue-property-decorator'
import type { ConfiguracaoDaLoja, FormLoja, Loja } from '@/models'
import { raizesDe } from '@/shareds/nova-edicao-de-loja/catalogo-de-parametros'
import type { ParametroDaLoja } from '@/shareds/nova-edicao-de-loja/catalogo-de-parametros'
import LinhaDeParametro from './LinhaDeParametro.vue'

@Component({
	components: { LinhaDeParametro },
})
export default class ListaDeParametros extends Vue {
	@Prop({ type: Array, required: true }) parametros!: ParametroDaLoja[]
	@Prop({ type: Object, required: true }) loja!: FormLoja
	@Prop({ type: Object, default: null }) anterior!: FormLoja | null
	@Prop({ type: Object, required: true }) padrao!: Partial<ConfiguracaoDaLoja>
	@Prop({ type: String, default: '' }) busca!: string
	/** Resultado de busca: sem aninhar, mostrando também o que está escondido e por quê. */
	@Prop({ type: Boolean, default: false }) plana!: boolean
	@Prop({ type: String, default: null }) destaque!: string | null
	@Prop({ type: Array, default: () => [] }) lojasDoGrupoEconomico!: Loja[]
	@Prop({ type: Boolean, default: false }) carregandoLojasDoGrupoEconomico!: boolean

	get grupos() {
		const grupos: { nome: string; parametros: ParametroDaLoja[] }[] = []
		const raizes = this.plana ? this.parametros : raizesDe(this.parametros)
		raizes.forEach(parametro => {
			let grupo = grupos.find(({ nome }) => nome === parametro.grupo)
			if (!grupo) {
				grupo = { nome: parametro.grupo, parametros: [] }
				grupos.push(grupo)
			}
			grupo.parametros.push(parametro)
		})
		return grupos
	}
}
